<template>
  <div class="w-100">
    <proa-card class="h-100 d-flex flex-column" no-padding>
      <template v-slot:header>
        <div class="d-flex justify-content-between align-items-center">
          <proa-back-button
            @onClick="onClickBackButton"
          />
          <proa-heading class="group-chat-name" detail>{{ $t('pages.management.basicInformation.organizationInformation') }}</proa-heading>
          <div/>
        </div>
      </template>
      <div class="organization-information-content">
        <table class="table-attributes">
          <tbody>
            <tr>
              <th>{{ $t('models.organization.attributes.name') }}</th>
              <td>
                <span class="attribute-wrapper" @click="editOrganizationNameModal = true">
                  <img :src="require('@/assets/images/icons/edit.png')"/>
                  <span>{{ currentOrganization.name }}</span>
                </span>
              </td>
              <!-- <td class="assets-column">
                <proa-button>
                  {{ $t('pages.indexManagementOrganization.organizationNameChange') }}
                </proa-button>
              </td> -->
            </tr>
            <tr>
              <th>{{ $t('models.organization.planInUse') }}</th>
              <td>
                <span class="mr-3">{{ currentLicensedPlan.planName }}</span>
                <span>{{ currentLicensedPlan.price | currencyJPY }} / {{ $t('common.month') }}</span>
              </td>
            </tr>
            <tr>
              <th>{{ $t('models.organization.seets') }}</th>
              <td>{{ `${currentOrganization.currentSeats} / ${currentLicensedPlan.maxUsers + currentSeatTotalUsersCount}` }}</td>
              <td/>
            </tr>
            <tr>
              <th>{{ $t('models.organization.groups') }}</th>
              <td>{{ `${currentOrganization.currentGroups} / ${currentLicensedPlan.maxGroups || '&infin;'}` }}</td>
              <td/>
            </tr>
          </tbody>
        </table>
      </div>
    </proa-card>
    <edit-name-modal
      :modal="editOrganizationNameModal"
      :name="currentOrganization.name"
      :loading="updateOrganizationLoading"
      @close="editOrganizationNameModal = false"
      @onUpdateName="onUpdateName"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import SeatPlanMaster from '@/store/models/admin/SeatPlanMaster'
import EditNameModal from '@/components/molecules/management/organization/EditNameModal'

export default {
  name: 'IndexManagementOrganization',
  components: {
    EditNameModal
  },
  computed: {
    currentSeatTotalUsersCount: function() {
      return this.currentLicensedPlan.seatPlanMasterIds.map(seatPlanMasterId => {
        return this.seatPlanMasters.filter((seatPlanMaster) => seatPlanMasterId == seatPlanMaster.id)[0]?.maxSeats
      }).filter((v) => v).reduce((a, b) => a + b, 0)
    },
    seatPlanMasters: function() {
      return SeatPlanMaster.all()
    },
    ...mapGetters({
      currentOrganization: 'auth/currentOrganization',
      currentLicensedPlan: 'auth/currentLicensedPlan'
    })
  },
  data() {
    return {
      editOrganizationNameModal: false,
      updateOrganizationLoading: false
    }
  },
  methods: {
    onClickBackButton: function() {
      this.$router.push({ name: 'management' })
    },
    async onUpdateName(name) {
      this.updateOrganizationLoading = true
      await this.apiPutOrganization({
        name: name
      })
      this.updateOrganizationLoading = this.editOrganizationNameModal = false
    },
    ...mapActions({
      apiGetSeatPlanMasters: 'entities/seatPlanMasters/index',
      apiPutOrganization: 'managedOrganization/update'
    })
  },
  created() {
    this.apiGetSeatPlanMasters()
  }
}
</script>

<style scoped lang="scss">
@import "@/styles/variables";
@import "@/styles/mediaquery";

.organization-information-content {
  flex-grow: 1;
  height: 100%;
  display: flex;
  flex-direction: column;

  .table-attributes {
    width: 100%;

    tr {
      display: block;
      border-bottom: 1px solid $light-border-color;
      padding: 15px 20px;

      @include mq(md) {
        display: table-row;
        border-bottom: 1px solid $dark-border-color;
        padding: 0;
      }
    }

    th {
      display: block;
      width: 100%;
      padding: 0;
      font-weight: 600;

      @include mq(md) {
        display: table-cell;
        width: 1px;
        white-space: nowrap;
        padding: 20px 50px 20px 20px;
      }
    }

    td {
      display: block;
      width: 100%;
      padding: 0;
      word-break: break-all;

      @include mq(md) {
        display: table-cell;
        width: auto;
        padding: 20px 20px 20px 0;
      }

      .attribute-wrapper {
        display: flex;
        cursor: pointer;

        img {
          width: 20px;
          height: 20px;
          margin-right: 10px;
        }
      }
    }
  }
}
</style>
